export const smoothScrollToTop = (duration: number = 500): void => {
	const start: number = window.scrollY; // Get current scroll position
	const target: number = 0; // Target scroll position
	const distance: number = target - start; // Distance to scroll
	const startTime: number = performance.now(); // Start time for the animation

	const animateScroll = (currentTime: number): void => {
		const timeElapsed: number = currentTime - startTime; // Time elapsed since the start
		const progress: number = Math.min(timeElapsed / duration, 1); // Progress percentage (0 to 1)

		// Easing function for a smooth scroll
		const easeInOut = (t: number): number => (t < 0.5 ? 2 * t * t : -1 + (4 - 2 * t) * t);
		const scrollY: number = start + distance * easeInOut(progress); // Calculate current scroll position

		window.scrollTo(0, scrollY); // Set the new scroll position

		// Continue animating if progress is less than 1
		if (progress < 1) {
			requestAnimationFrame(animateScroll);
		}
	};

	requestAnimationFrame(animateScroll); // Start the animation
};
